import { render, staticRenderFns } from "@/shared/components/convocation-card/convocation-card.pug?vue&type=template&id=12965f70&scoped=true&lang=pug&external"
import script from "./convocation-card.component.vue?vue&type=script&lang=ts"
export * from "./convocation-card.component.vue?vue&type=script&lang=ts"
import style0 from "@/shared/components/convocation-card/convocation-card.scss?vue&type=style&index=0&id=12965f70&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12965f70",
  null
  
)

export default component.exports